/* c8 ignore start */
import { SAT_SERVICE } from "@/utils/services";

const mspRoutes = {
  path: "/msp",
  component: () => import("@/layouts/Msp/MspLayout.vue"),
  children: [
    {
      path: "security_awareness_training",
      name: "msp-security_awareness_training",
      component: () =>
        import("@/modules/SecurityAwarnessTraining/views/Msp/msp.index.vue"),
      redirect: {
        name: "msp-security_awareness_training-overview",
      },
      meta: {
        solutionId: SAT_SERVICE,
      },
      children: [
        {
          path: "overview",
          name: "msp-security_awareness_training-overview",
          component: () =>
            import(
              "@/modules/SecurityAwarnessTraining/views/Msp/overview/overview.index.vue"
            ),
        },
        {
          path: "overview/details",
          name: "msp-security_awareness_training-details",
          component: () =>
            import(
              "@/modules/SecurityAwarnessTraining/views/Msp/campaign-details/campaign-details.index.vue"
            ),
        },
        {
          path: "overview/schedule_sat",
          name: "msp-security_awareness_training-overview-schedule_sat",
          component: () =>
            import(
              "@/modules/SecurityAwarnessTraining/views/Msp/schedule-sat/schedule-sat.index.vue"
            ),
        },
        {
          path: "sat_campaigns",
          name: "msp-security_awareness_training-sat_campaigns",
          component: () =>
            import(
              "@/modules/SecurityAwarnessTraining/views/Msp/sat-campaigns/sat-campaigns.index.vue"
            ),
        },
        {
          path: "sat_campaigns/details",
          name: "msp-security_awareness_training-sat_campaigns-details",
          component: () =>
            import(
              "@/modules/SecurityAwarnessTraining/views/Msp/campaign-details/campaign-details.index.vue"
            ),
        },
        {
          path: "sat_campaigns/schedule_sat",
          name: "msp-security_awareness_training--sat_campaigns-schedule_sat",
          component: () =>
            import(
              "@/modules/SecurityAwarnessTraining/views/Msp/schedule-sat/schedule-sat.index.vue"
            ),
        },
      ],
    },
  ],
};

export { mspRoutes };

export default {};
/* c8 ignore end */
